module.exports = __webpack_public_path__ + "static/media/bus_icon.8c7dfa10.svg";